export const MateriaisHidraulicosIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.93095 4V5.42857V6.85713H8.74992M3.33325 4C3.33325 4 3.33325 7.87998 3.33325 9.14284C3.33325 10.4057 4.36199 11.4285 5.6321 11.4285H8.74992M12.0689 15.9999V11.4285H11.6666M16.6666 15.9999C16.6666 14.4761 16.6666 10.9714 16.6666 9.14284C16.6666 7.31427 15.134 6.85713 14.3677 6.85713H13.908H11.8514"
        stroke="black"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M10.8333 6.16663C11.1094 6.16663 11.3333 6.39048 11.3333 6.66663L11.3333 11.6666C11.3333 11.9428 11.1094 12.1666 10.8333 12.1666L9.99992 12.1666C9.72378 12.1666 9.49992 11.9428 9.49992 11.6666L9.49992 6.66663C9.49992 6.39048 9.72378 6.16663 9.99992 6.16663L10.8333 6.16663Z"
        stroke="black"
        strokeLinejoin="round"
      />
      <path
        d="M8.83333 2.40002C8.83333 2.12388 8.60948 1.90002 8.33333 1.90002L2.5 1.90002C2.22386 1.90002 2 2.12388 2 2.40002V3.20002C2 3.47616 2.22386 3.70002 2.5 3.70002L8.33333 3.70002C8.60948 3.70002 8.83333 3.47616 8.83333 3.20002V2.40002Z"
        stroke="black"
        strokeLinejoin="round"
      />
      <path
        d="M18.0001 16.7999C18.0001 16.5238 17.7762 16.2999 17.5001 16.2999H11.6667C11.3906 16.2999 11.1667 16.5238 11.1667 16.7999V17.5999C11.1667 17.8761 11.3906 18.0999 11.6667 18.0999H17.5001C17.7762 18.0999 18.0001 17.8761 18.0001 17.5999V16.7999Z"
        stroke="black"
        strokeLinejoin="round"
      />
    </svg>
  );
};
